module.exports = __webpack_public_path__ + "img/advan-two.8f218e0a.png";